import React from "react";

interface Props {
  size?: number | string;
  className?: string;
  color?: string;
}

export const VerifiedIcon: React.FC<Props> = ({ size = 24, className = "", color = "currentColor" }) => {
  return (
    <svg
      viewBox="123.507 102.073 832.986 875.854"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      className={className} 
      style={{ color }}
    >
      <g>
        <path
          d="M587.317 817.312C573.416 864.496 506.584 864.496 492.683 817.312L492.683 817.312C482.887 784.06 442.751 771.019 415.28 792.163L415.28 792.163C376.3 822.165 322.231 782.881 338.72 736.538L338.72 736.538C350.34 703.878 325.534 669.736 290.882 670.695L290.882 670.695C241.712 672.056 221.059 608.494 261.639 580.693L261.639 580.693C290.236 561.101 290.236 518.899 261.639 499.307L261.639 499.307C221.059 471.506 241.712 407.944 290.882 409.305L290.882 409.305C325.534 410.264 350.34 376.122 338.72 343.462L338.72 343.462C322.231 297.119 376.3 257.835 415.28 287.837L415.28 287.837C442.751 308.981 482.887 295.94 492.683 262.688L492.683 262.688C506.584 215.504 573.416 215.504 587.317 262.688L587.317 262.688C597.113 295.94 637.249 308.981 664.72 287.837L664.72 287.837C703.7 257.835 757.769 297.119 741.28 343.462L741.28 343.462C729.66 376.122 754.466 410.264 789.118 409.305L789.118 409.305C838.288 407.944 858.941 471.506 818.361 499.307L818.361 499.307C789.764 518.899 789.764 561.101 818.361 580.693L818.361 580.693C858.941 608.494 838.288 672.056 789.118 670.695L789.118 670.695C754.466 669.736 729.66 703.878 741.28 736.538L741.28 736.538C757.769 782.881 703.7 822.165 664.72 792.163L664.72 792.163C637.249 771.019 597.113 784.06 587.317 817.312L587.317 817.312Z"
          fill="currentColor"
        />

        <path
          d="M506.456 612.261L647.977 467.739"
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="50"
        />
        <path
          d="M432.023 542.824L506.456 612.261"
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="50"
        />
      </g>
    </svg>
  );
};
